import React, { useMemo, useState } from 'react'

import { Box, ButtonPopover, LazySearch, MenuOption, RadioFormGroup, RoundedPlainTextButton } from '@percept/mui'

import { ArrowDropDown } from '@percept/mui/icons'

import { getAllTimezones, TimezoneName } from 'countries-and-timezones'

import { some } from 'lodash-es'


const allTimezones = getAllTimezones()

const timezoneOptions: (MenuOption<string> & { searchValues: string[] })[] = (
  (Object.keys(allTimezones) as TimezoneName[])
  // Filter out any values not suitable for selection
    .filter( t => !t.startsWith('Etc'))
    .sort()
    .map( value => ({
      value,
      label: value,
      searchValues: [
        value.toLowerCase(),
        ...allTimezones[value].countries.map( c => c.toLowerCase()),
      ],
    }))
)


export type TimezoneSelectProps = {
  value: string | null | undefined
  onChange: (value: string) => void
}

export const TimezoneSelect = ({
  value,
  onChange,
}: TimezoneSelectProps): JSX.Element => {

  const [searchValue, setSearchValue] = useState<string>('')

  const filteredOptions = useMemo(() => {
    if( !searchValue ){
      return timezoneOptions
    }
    const matchValue = searchValue.toLowerCase()
    return timezoneOptions.filter( o => some(o.searchValues, s => s.includes(matchValue)) )
  }, [searchValue])

  return (
    <ButtonPopover
      variant='contained'
      ButtonComponent={RoundedPlainTextButton}
      endIcon={<ArrowDropDown />}
      color='secondary'
      buttonContent={value || 'Select Timezone'}>
      { ({ onClose }): JSX.Element => (
        <Box display='flex' flexDirection='column' p={2}>

          <Box mb={1}>
            <LazySearch
              value={searchValue}
              fullWidth
              delay={150}
              placeholder='Search...'
              onChange={(e): void => {
                setSearchValue(e.target.value)
              }}
              onReset={(): void => {
                setSearchValue('')
              }} />          
          </Box>

          <RadioFormGroup
            value={value || ''}
            options={filteredOptions}
            scrollable
            maxHeight='30em'
            onChange={(value): void => {
              onChange(value)
              onClose()
              setSearchValue('')
            }} />
        </Box>
      )}
    </ButtonPopover>
  )
}
